module.exports = __webpack_public_path__ + "static/media/Oil-white.d80ad736.svg";